module.exports = __webpack_public_path__ + "img/operators.d16d1881.svg";